export default "__VITE_ASSET__BD90_0$3__"